<template>
    <div class="boot-shell page-bg-standard" aria-label="Loading application">
        <aside class="boot-sidebar">
            <div class="boot-logo skeleton-pulse"></div>
            <div v-for="index in 7" :key="index" class="boot-menu-row skeleton-pulse"></div>
        </aside>
        <main class="boot-main">
            <div class="boot-title skeleton-pulse"></div>
            <div class="boot-subtitle skeleton-pulse"></div>
            <div class="boot-tabs skeleton-pulse"></div>
            <div class="boot-card skeleton-pulse"></div>
            <div class="boot-card skeleton-pulse"></div>
        </main>
    </div>
</template>

<style scoped>
.boot-shell { min-height: 100vh; display: grid; grid-template-columns: 20rem 1fr; background: var(--theme-page, #1f1f1f); color: var(--theme-text, white); }
.boot-sidebar { padding: 1.5rem 1.25rem; border-right: 1px solid var(--theme-border, rgba(255,255,255,.08)); background: var(--theme-inset, #191919); }
.boot-logo { width: 3rem; height: 2rem; margin-bottom: 2.5rem; }
.boot-menu-row { height: 2.75rem; margin: .75rem 0; border-radius: .75rem; }
.boot-main { padding: 2rem 2.5rem; }
.boot-title { width: 12rem; height: 2.25rem; margin: 0 auto .75rem; }
.boot-subtitle { width: 22rem; max-width: 70%; height: 1.25rem; margin: 0 auto 2rem; }
.boot-tabs { height: 3.25rem; margin-bottom: 1.5rem; border-radius: .5rem; }
.boot-card { height: 15rem; margin-bottom: 1.25rem; border-radius: 1rem; }
.skeleton-pulse { background: linear-gradient(90deg, var(--theme-surface, #292929) 25%, var(--theme-hover, #333) 50%, var(--theme-surface, #292929) 75%); background-size: 200% 100%; animation: boot-pulse 1.4s infinite; }
@keyframes boot-pulse { to { background-position: -200% 0; } }
@media (max-width: 900px) { .boot-shell { grid-template-columns: 1fr; } .boot-sidebar { display: none; } .boot-main { padding: 1.25rem; } }
</style>
